function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { concat, uint64be } from '../lib/buffer_utils.js';
import checkIvLength from '../lib/check_iv_length.js';
import checkCekLength from './check_cek_length.js';
import timingSafeEqual from './timing_safe_equal.js';
import { JOSENotSupported, JWEDecryptionFailed, JWEInvalid } from '../util/errors.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
function cbcDecrypt(_x, _x2, _x3, _x4, _x5, _x6) {
  return _cbcDecrypt.apply(this, arguments);
}
function _cbcDecrypt() {
  _cbcDecrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(enc, cek, ciphertext, iv, tag, aad) {
    var keySize, encKey, macKey, macData, expectedTag, macCheckPassed, plaintext, _t2, _t3, _t4, _t5, _t6;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (cek instanceof Uint8Array) {
            _context2.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput(cek, 'Uint8Array'));
        case 1:
          keySize = parseInt(enc.slice(1, 4), 10);
          _context2.n = 2;
          return crypto.subtle.importKey('raw', cek.subarray(keySize >> 3), 'AES-CBC', false, ['decrypt']);
        case 2:
          encKey = _context2.v;
          _context2.n = 3;
          return crypto.subtle.importKey('raw', cek.subarray(0, keySize >> 3), {
            hash: "SHA-".concat(keySize << 1),
            name: 'HMAC'
          }, false, ['sign']);
        case 3:
          macKey = _context2.v;
          macData = concat(aad, iv, ciphertext, uint64be(aad.length << 3));
          _t2 = Uint8Array;
          _context2.n = 4;
          return crypto.subtle.sign('HMAC', macKey, macData);
        case 4:
          _t3 = _context2.v.slice(0, keySize >> 3);
          expectedTag = new _t2(_t3);
          try {
            macCheckPassed = timingSafeEqual(tag, expectedTag);
          } catch (_unused) {}
          if (macCheckPassed) {
            _context2.n = 5;
            break;
          }
          throw new JWEDecryptionFailed();
        case 5:
          _context2.p = 5;
          _t4 = Uint8Array;
          _context2.n = 6;
          return crypto.subtle.decrypt({
            iv: iv,
            name: 'AES-CBC'
          }, encKey, ciphertext);
        case 6:
          _t5 = _context2.v;
          plaintext = new _t4(_t5);
          _context2.n = 8;
          break;
        case 7:
          _context2.p = 7;
          _t6 = _context2.v;
        case 8:
          if (plaintext) {
            _context2.n = 9;
            break;
          }
          throw new JWEDecryptionFailed();
        case 9:
          return _context2.a(2, plaintext);
      }
    }, _callee2, null, [[5, 7]]);
  }));
  return _cbcDecrypt.apply(this, arguments);
}
function gcmDecrypt(_x7, _x8, _x9, _x0, _x1, _x10) {
  return _gcmDecrypt.apply(this, arguments);
}
function _gcmDecrypt() {
  _gcmDecrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(enc, cek, ciphertext, iv, tag, aad) {
    var encKey, _t7, _t8, _t9;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (!(cek instanceof Uint8Array)) {
            _context3.n = 2;
            break;
          }
          _context3.n = 1;
          return crypto.subtle.importKey('raw', cek, 'AES-GCM', false, ['decrypt']);
        case 1:
          encKey = _context3.v;
          _context3.n = 3;
          break;
        case 2:
          checkEncCryptoKey(cek, enc, 'decrypt');
          encKey = cek;
        case 3:
          _context3.p = 3;
          _t7 = Uint8Array;
          _context3.n = 4;
          return crypto.subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: 'AES-GCM',
            tagLength: 128
          }, encKey, concat(ciphertext, tag));
        case 4:
          _t8 = _context3.v;
          return _context3.a(2, new _t7(_t8));
        case 5:
          _context3.p = 5;
          _t9 = _context3.v;
          throw new JWEDecryptionFailed();
        case 6:
          return _context3.a(2);
      }
    }, _callee3, null, [[3, 5]]);
  }));
  return _gcmDecrypt.apply(this, arguments);
}
var decrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(enc, cek, ciphertext, iv, tag, aad) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!isCryptoKey(cek) && !(cek instanceof Uint8Array))) {
            _context.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [cek].concat(_toConsumableArray(types), ['Uint8Array'])));
        case 1:
          if (iv) {
            _context.n = 2;
            break;
          }
          throw new JWEInvalid('JWE Initialization Vector missing');
        case 2:
          if (tag) {
            _context.n = 3;
            break;
          }
          throw new JWEInvalid('JWE Authentication Tag missing');
        case 3:
          checkIvLength(enc, iv);
          _t = enc;
          _context.n = _t === 'A128CBC-HS256' ? 4 : _t === 'A192CBC-HS384' ? 4 : _t === 'A256CBC-HS512' ? 4 : _t === 'A128GCM' ? 5 : _t === 'A192GCM' ? 5 : _t === 'A256GCM' ? 5 : 6;
          break;
        case 4:
          if (cek instanceof Uint8Array) checkCekLength(cek, parseInt(enc.slice(-3), 10));
          return _context.a(2, cbcDecrypt(enc, cek, ciphertext, iv, tag, aad));
        case 5:
          if (cek instanceof Uint8Array) checkCekLength(cek, parseInt(enc.slice(1, 4), 10));
          return _context.a(2, gcmDecrypt(enc, cek, ciphertext, iv, tag, aad));
        case 6:
          throw new JOSENotSupported('Unsupported JWE Content Encryption Algorithm');
        case 7:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function decrypt(_x11, _x12, _x13, _x14, _x15, _x16) {
    return _ref.apply(this, arguments);
  };
}();
export default decrypt;